import { SvgIconProps, SvgIcon } from '@mui/material';
import styles from './ccf-agent-search-email-inbound-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfAgentSearchEmailInboundIconProps extends SvgIconProps {}

export function CcfAgentSearchEmailInboundIcon(
  props: CcfAgentSearchEmailInboundIconProps
) {
  return (
    <SvgIcon
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 26 13"
        id="EMAIL_IB"
        {...props}
      >
        <path
          d="M25.0965 0.453429C24.8565 0.281999 24.6165 0.196289 24.2965 0.196289H11.4965C11.1765 0.196289 10.9365 0.281999 10.6965 0.453429L17.8965 5.2534L25.0965 0.453429Z"
          fill="#E6258D"
        ></path>
        <path
          d="M25.8965 1.91052L18.2965 6.96764C18.2165 6.96764 18.0565 7.05334 17.8965 7.05334C17.7365 7.05334 17.5765 6.96764 17.4965 6.88194L9.89648 1.91052V10.4819C9.89648 11.4248 10.6165 12.1962 11.4965 12.1962H24.2965C25.1765 12.1962 25.8965 11.4248 25.8965 10.4819V1.91052Z"
          fill="#E6258D"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.12649 1.19629C5.12649 0.644009 4.67877 0.196289 4.12649 0.196289C3.5742 0.196289 3.12649 0.644009 3.12649 1.19629V7.3965H1.19699C0.957966 7.3965 0.814931 7.6624 0.94665 7.8618L3.88645 12.3133C4.00572 12.4939 4.27114 12.4926 4.38868 12.3109L7.2681 7.8594C7.39722 7.6598 7.25393 7.3965 7.0162 7.3965H5.12649V1.19629Z"
          fill="#E6258D"
        ></path>
    </SvgIcon>
  );
}

export default CcfAgentSearchEmailInboundIcon;
